import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

import itIt from './locale/it_IT.json'
import enUS from './locale/en_US.json'
import esES from './locale/es_ES.json'

const getBrowserLocale = (options) => {
	const defaultOptions = { countryCodeOnly: false }
	const opt = Object.assign(defaultOptions, options)
	const navigatorLocale =
		navigator.languages !== undefined ? navigator.languages[0] : navigator.language

	if (!navigatorLocale) {
		return undefined
	}

	const trimmedLocale = opt.countryCodeOnly ? navigatorLocale.trim().split(/-|_/)[0] : navigatorLocale.trim()

	return trimmedLocale
}

const messages = {
	it: itIt,
	en: enUS,
	es: esES
}

const currentLanguage = getBrowserLocale({ countryCodeOnly: true })
let currentLocale = 'en'
switch (currentLanguage) {
	case 'it':
		currentLocale = 'it'
		break
	case 'es':
		currentLocale = 'es'
		break
	case 'en':
		currentLocale = 'en'
}

export default new VueI18n({
	locale        : currentLocale,
	fallbackLocale: 'en',
	messages,
})
